<template>
    <div class="form-group">
        <label :for="name">{{label}}</label>
        <div class="input-group" id="show_hide_password">
            <input v-if="!passwordShown" aria-required="true" :aria-describedby="getPasswordId" class="form-control" v-bind:class="{'error': dataInError}" :id="name" :name="name" type="password" v-model="passwordValue" @blur="onPasswordBlur" @keyup="emitPassword(); isValid();">
            <input v-else class="form-control" aria-required="true" v-bind:class="{'error': dataInError}" :id="name" :name="name" type="text" v-model="passwordValue" @blur="onPasswordBlur" @keyup="emitPassword">
            <div class="input-group-append">
                <button class="input-group-text icon-button" type="button" role="switch" @click="togglePasswordDisplay" :aria-pressed="String(passwordShown)" v-tooltip="passwordShown ? 'Hide password' : 'Show password'">
                    <fa-icon v-if="!passwordShown" :icon="['fas','eye-slash']" />
                    <fa-icon v-else :icon="['fas','eye']" />
                    <span class="sr-only">Show or hide password</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import addVModelWatchers from "../mixins/addVModelWatchers.js";

    export default {
        name: "Password",

        mixins: [
            addVModelWatchers({
                modelProp: "inError",
                modelDataName: "dataInError"
            })
        ],

        emits: ['update-password', 'blur-password'],

        props: {
            label: String,
            name: {
                type: String,
                default: "password"
            },
            inError: {
                type: Boolean,
                default: false
            },
            overrideValid: {
                type: Boolean,
                default: false
            },
            getPasswordId: {
                type: String,
                default: () => null
            }
        },

        data: function() {
            return {
                passwordValue: "",
                passwordShown: false
            }
        },

        methods: {
            togglePasswordDisplay: function() {
                this.passwordShown = !this.passwordShown;
            },

            getValue: function() {
                return this.passwordValue;
            },

            clear: function() {
                this.passwordValue= "";
                this.clearInError();
            },

            isValid: function() {
                var valid = this.passwordValue !== "";

                if (!this.overrideValid) {
                    if (!valid) {
                        this.markInError();
                    } else {
                        this.clearInError();
                    }
                }

                return valid;
            },

            emitPassword: function() {
                this.$emit('update-password', this.passwordValue);
            },

            clearInError: function() {
                this.dataInError = false;
            },

            markInError: function() {
                this.dataInError = true;
            },

            onPasswordBlur: function(e) {
                this.isValid();
                this.$emit('blur-password', e);
            }
        }
    }
</script>

<style scoped>

</style>